import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DefaultModule, PrimeModule } from '@module';

import { SegmentedControlComponent } from 'pn-core-code';

import { SelectButton } from 'primeng/selectbutton';

@Component({
  selector: 'shared-segmented-control',
  standalone: true,
  imports: [DefaultModule, PrimeModule, SegmentedControlComponent],
  templateUrl: './shared-segmented-control.component.html',
  styleUrl: './shared-segmented-control.component.scss'
})
export class SharedSegmentedControlComponent {
  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  statusOptionsList: any[] = [{ label: 'All', value: undefined }, { label: 'Active', value: true }, { label: 'Inactive', value: false }];


  onValueChange(event: any) {
    // console.log('onValueChange', event);
    this.valueChange.emit(event);
  }
}
